import React, { useEffect } from "react";
import "./styles.css";

const Toast = ({ display, message, onClose }) => {
  useEffect(() => {
    let timer;
    if (display) {
      timer = setTimeout(() => {
        onClose();
      }, Math.min(500 + 50 * parseInt(message.length),3000));
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [display, onClose]);

  return (
    <div className={`toast ${display ? "show" : ""}`}>
      <p>{`${message}`}</p>
    </div>
  );
};

export default Toast;
